// extracted by css-extract-rspack-plugin
export default {"LinkedPullRequestToken":"linked-pr-token-module__LinkedPullRequestToken__h6S_g4r"};